import { createAction } from '@reduxjs/toolkit';
import { UserPayloadTypes } from '../../shared/types/type';

export const fetchRoleList = createAction<Number>('FETCH_ROLE_LIST_INIT');
export const fetchRoleListSuccess = createAction<any>('FETCH_ROLE_LIST_SUCCESS');
export const fetchRoleListFailed = createAction('FETCH_ROLE_LIST_FAILED');

export const addNewUser=createAction<UserPayloadTypes>('ADD_NEW_USER_INIT');
export const addNewUserSuccess=createAction('ADD_NEW_USER_SUCCESS');
export const addNewUserFailed=createAction('ADD_NEW_USER_FAILED');